export { default } from './FooterBottom';
